import { render } from "./result.vue?vue&type=template&id=0bca79f4&scoped=true&ts=true"
import script from "./result.vue?vue&type=script&lang=ts"
export * from "./result.vue?vue&type=script&lang=ts"

import "./result.vue?vue&type=style&index=0&id=0bca79f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bca79f4"]])

export default __exports__